import {BASE_API_URL, paramHeaders} from "../../app/AppConfig";
import {GetCurrentLocale} from "../../components/Utils";
import {RootObjectSearchResults, SearchResult} from "../Entity/SearchResult";
import axios from "axios";

export async function getReadSearchResultsRep(query : string|null = null): Promise<SearchResult[]> {
  try {
    const locale = GetCurrentLocale()
    let urlToGet = BASE_API_URL + '/search';
    let params = new URLSearchParams();
    let filtersQuery = query !== null && query.length > 0  ?
      query : '';

    if (filtersQuery === '') {
      return ([]);
    }
    params.append('q', filtersQuery);
    params.append('locale', locale + '_BE')
    const response = await axios.get<SearchResult[]>(
      urlToGet,
      {
        params: params,
        headers: paramHeaders
      },
    )
    return response.data;
  } catch (err) {
    throw err
  }
}
